module.exports = {"vehicleLabel":{"single":"Veículo","multiple":"Veículos"},"activeLabel":"Ativo","accessionDate":"Data de adesão","bonificationEndDate":"Promoção de","bonificationValid":"Válida até","currency":"R$","monthlyPayment":"Mensalidade","totalLimit":"Limite total"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/PlanResume/data.json
// module id = 1868
// module chunks = 0